/*********************
Word Difficulty Rule
*********************/
import Rule from '../Rule';
import {
  ruleInputTypes,
  ruleTypes,
  masteryConditionEnums,
  masteryConditionValues,
} from '../../../constants';
import { LOG_DECISION_CONTEXT } from '../../../config';

export default class WordDifficultyRule extends Rule {
  constructor(masteryCondition) {
    super([ruleInputTypes.word_AREA_AOA, ruleInputTypes.studentAREA]);
    this.ruleType = ruleTypes.DIFFICULTY;
    this.masteryCondition = masteryCondition;
  }

  run(state) {
    // Get the params that we need to calculate area delta
    const { word_AREA_AOA, studentAREA } = state;

    // If we're missing any inputTypes, return false
    let ruleParams = [word_AREA_AOA, studentAREA];
    const hasAllInputs = Object.values(ruleParams).every(input => (input !== null));
    if(!hasAllInputs) {
      console.log('Error: runRule called without all necessary inputs. This shouldn\'t ever occur: ', [ruleParams,this.inputTypes]);
      return false;
    }

    const condition = this.masteryCondition[0];
    const conditionBool = this.masteryCondition[1];
    const conditionValue = masteryConditionValues[condition];
    const areaDelta = studentAREA - word_AREA_AOA;

    let meetsMasteryCondition = false;
    switch(condition) {
      case masteryConditionEnums.ALMOST_CERTAINLY_MASTERED:
      case masteryConditionEnums.LIKELY_MASTERED:
      case masteryConditionEnums.MAYBE_MASTERED:
      case masteryConditionEnums.PROBABLY_MASTERED:
        meetsMasteryCondition = areaDelta >= conditionValue;
        break;
      case masteryConditionEnums.VERY_CHALLENGING:
      case masteryConditionEnums.SUPER_CHALLENGING:
        meetsMasteryCondition = areaDelta <= conditionValue;
        break;
      case masteryConditionEnums.APPROPRIATELY_CHALLENGING:
      case masteryConditionEnums.ZPD_WIDE:
        meetsMasteryCondition = (areaDelta <= conditionValue[0]) && (areaDelta >= conditionValue[1]);
        break;
    }

    // invert decision based on user-specified bool
    if(!conditionBool) {
      meetsMasteryCondition = !meetsMasteryCondition;
    }

    let decisionContext;
    let log;
    if(LOG_DECISION_CONTEXT) {
      decisionContext = {[(this.ruleType + '_' + this.masteryCondition + '_' + meetsMasteryCondition)]: {
        word_AREA_AOA,
        studentAREA,
      }};

      log = `${meetsMasteryCondition ? 'PASSED': 'FAILED'}: wordDifficultyCheck=>` +
        [
          `(${!conditionBool ? '!' : ''}${condition}: ${conditionValue})`,
          `input:[areaDelta: ${areaDelta.toFixed(2)}`,
          `studentArea: ${studentAREA.toFixed(2)}`,
          `word_AREA_AOA: ${word_AREA_AOA}]`,
        ].join(', ');
    }
    return {
      stateMeetsRuleCondition: meetsMasteryCondition,
      decisionContext,
      log,
    }
  }
}